import React from 'react';
import { Typography, Button, Box, List, ListItem, ListItemText, ListItemAvatar, Avatar } from '@mui/material';
import ModalWrapper from '../components/ModalWrapper';
import { ShoppingListGrocery } from '../types/ShoppingListGrocery';

interface ShoppingListItemsPreviewModalProps {
  open: boolean;
  onClose: () => void;
  listName: string;
  items: ShoppingListGrocery[];
}

const ShoppingListItemsPreviewModal: React.FC<ShoppingListItemsPreviewModalProps> = ({
  open,
  onClose,
  listName,
  items,
}) => {
  return (
    <ModalWrapper open={open} onClose={onClose}>
      <Typography variant="h6" gutterBottom>
        Items in "{listName}"
      </Typography>

      {items.length === 0 ? (
        <Typography variant="body1" color="text.secondary">
          No items in this list.
        </Typography>
      ) : (
        <List sx={{ maxHeight: 400, overflow: 'auto' }}>
          {items.map((item) => (
            <ListItem key={item.id}>
              <ListItemAvatar>
                <Avatar
                  src={item.grocery_details.image || `${process.env.REACT_APP_IMAGES_URL}/placeholder-grocery.svg`}
                  variant="rounded"
                  sx={{ width: 40, height: 40 }}
                />
              </ListItemAvatar>
              <ListItemText
                primary={`${item.quantity}x ${item.grocery_details.name}`}
                secondary={item.grocery_details.brand || ''}
              />
            </ListItem>
          ))}
        </List>
      )}

      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
        <Button variant="outlined" color="primary" onClick={onClose}>
          Close
        </Button>
      </Box>
    </ModalWrapper>
  );
};

export default ShoppingListItemsPreviewModal;